module.exports = __webpack_public_path__ + "img/3-vertical-dots.ee8b9107.svg";